import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import Head from '../../components/Head';
import Layout from '../../layout';
import DashboardBigButton from '../../components/Dashboard/DashboardBigButton';
import { VaccineIcon, TasksIcon } from '../../assets/icons';

function MyHealth() {
  return (
    <Layout page="myHealth" innerPage>
      <Head>Minha Saúde</Head>
      <Box px={1}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <DashboardBigButton
              to="/minha-saude/quiz"
              type="quiz"
              icon={<img height={80} src={TasksIcon} alt="vaccine-icon" />}
              title="Questionário de Saúde"
            ></DashboardBigButton>
          </Grid>
          <Grid item xs={12} md={6}>
            <DashboardBigButton
              to="/minha-saude/vacina"
              type="vaccine"
              icon={<img height={70} src={VaccineIcon} alt="vaccine-icon" />}
              title="Vacinação"
              description={
                <>
                  Tome sua vacina contra <strong>gripe</strong>.
                </>
              }
            ></DashboardBigButton>
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
}

export default MyHealth;
